import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  getItemSoldOutEstimateSuccess,
  getItemSoldOutEstimateFailure
} from '../actions';

// Action to get sold out estimate for an item
export const asyncGetSoldOutEstimate = (itemId: string) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Construct the URL with query parameters
      let url = `/marketplace-service/api/v1/items/sold-out-estimate/${itemId}`
      const response = await backend.get(url);

      if (response.status === 200) {
        const soldOutEstimate = response.data;
        dispatch(getItemSoldOutEstimateSuccess(soldOutEstimate));
      } else {
        dispatch(getItemSoldOutEstimateFailure('Failed to get sold out estimate.'));
      }
    } catch (error) {
      console.error('Error fetching business items:', error);
      dispatch(getItemSoldOutEstimateFailure('Failed to get sold out estimate.'));
    }
  };
};